const mapEvents: StandardObjectInterface = {
    initializeMap: 'initialize-map',
    newAddressCoordinates: 'new-address-coordinates'
};

export default mapEvents;
